var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('faq'))+"\n    \n  ")]),_vm._v(" "),(_vm.country_code_cm == 'greece' && _vm.gateway_code =='mobivas')?_c('span',[_c('faq-paydash-greek')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d06f248","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cutemobi/Faq.vue
// module id = 2221
// module chunks = 0